import { render } from "./ProjectTabStory.vue?vue&type=template&id=a9e82118&scoped=true&ts=true"
import script from "./ProjectTabStory.vue?vue&type=script&lang=ts"
export * from "./ProjectTabStory.vue?vue&type=script&lang=ts"

import "./ProjectTabStory.vue?vue&type=style&index=0&id=a9e82118&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9e82118"]])

export default __exports__